export default __webpack_public_path__ + "static/iron-and-steelHero-0cdf59c1b6b8902277e1390007c9cf86.jpg";